import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { BuildingIcon } from 'lucide-react';
import { PortalBuilder } from '../components/PortalBuilder';
import { PartnerDashboard } from '../components/PartnerDashboard';
import { BrandingConfigurator } from '../components/BrandingConfigurator';
import { ModelMarketplace } from '../components/ModelMarketplace';
export function PartnerPortalsPage() {
  const {
    section
  } = useParams<{
    section: string;
  }>();
  const navigate = useNavigate();
  const [activeTab, setActiveTab] = useState<'builder' | 'dashboard' | 'branding' | 'marketplace'>('builder');
  useEffect(() => {
    if (section) {
      setActiveTab(section as any);
    }
  }, [section]);
  const handleTabChange = (tab: string) => {
    setActiveTab(tab as any);
    navigate(`/partner-portals/${tab}`);
  };
  const tabs = [{
    id: 'builder',
    label: 'Portal Builder'
  }, {
    id: 'dashboard',
    label: 'Partner Dashboard'
  }, {
    id: 'branding',
    label: 'Branding'
  }, {
    id: 'marketplace',
    label: 'Model Marketplace'
  }];
  return <div className="w-full h-screen flex flex-col bg-gray-50" data-id="element-5538">
      {/* Header */}
      <div className="bg-white border-b border-gray-200 px-6 py-4" data-id="element-5539">
        <div className="flex items-center justify-between" data-id="element-5540">
          <div data-id="element-5541">
            <div className="flex items-center gap-2" data-id="element-5542">
              <BuildingIcon className="w-6 h-6 text-red-600" data-id="element-5543" />
              <h1 className="text-2xl font-bold text-gray-900" data-id="element-5544">
                Partner-Branded GTM Portals
              </h1>
            </div>
            <p className="text-sm text-gray-600 mt-1" data-id="element-5545">
              Create white-label GTM portals for your customers
            </p>
          </div>
        </div>
      </div>
      {/* Tabs */}
      <div className="bg-white border-b border-gray-200 px-6" data-id="element-5546">
        <div className="flex gap-6" data-id="element-5547">
          {tabs.map(tab => <button key={tab.id} onClick={() => handleTabChange(tab.id)} className={`px-4 py-3 text-sm font-medium border-b-2 transition-colors ${activeTab === tab.id ? 'border-red-600 text-red-600' : 'border-transparent text-gray-600 hover:text-gray-900'}`} data-id="element-5548">
              {tab.label}
            </button>)}
        </div>
      </div>
      {/* Content */}
      <div className="flex-1 overflow-y-auto p-6" data-id="element-5549">
        {activeTab === 'builder' && <PortalBuilder data-id="element-5550" />}
        {activeTab === 'dashboard' && <PartnerDashboard data-id="element-5551" />}
        {activeTab === 'branding' && <BrandingConfigurator data-id="element-5552" />}
        {activeTab === 'marketplace' && <ModelMarketplace data-id="element-5553" />}
      </div>
    </div>;
}